import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelAccountsAddResolverErrorStatesEnum {
    GetClientFailed = ErrorStateScheduleEnum.PanelAccountsAddResolverErrorStatesStartIndex,
    GetClientNotFound
}
